import type { TFunction } from 'i18next'

export function formatMoney(amount: string | number | null | undefined, currency = 'RUB'): string {
  if (amount == null || amount === '') return '—'
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  if (!Number.isFinite(num)) return String(amount)
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num)
}

export function formatPriceSource(source: string | null | undefined, t: TFunction): string {
  if (!source) return '—'
  const key = `billing.priceSource.${source}`
  return t(key, { defaultValue: source })
}
